const getExperimentsInDataLayer = () => {
  const { dataLayer } = window;
  if (dataLayer === undefined) {
    return [];
  }
  return dataLayer
    .filter(item => item.event === 'optimizely_decision_web')
    .map(item => ({
      optimizely_experiment: item.optimizely_experiment,
      optimizely_variant: item.optimizely_variant,
    }));
};

const formantExperimentString = data => (
  `${data.optimizely_experiment}**${data.optimizely_variant}`
);

const getOptimizelyExperimentationString = () => (
  getExperimentsInDataLayer()
    .reduce((acc, curr, index) => (
      index === 0 ? formantExperimentString(curr) : `${acc}****${formantExperimentString(curr)}`
    ), '')
);
/* eslint-disable import/prefer-default-export */
export {
  getOptimizelyExperimentationString,
};
/* eslint-enable import/prefer-default-export */
